import React from "react";
import LZString from 'lz-string';
import Toastr from 'toastr';
import AxisLiveStream from "./AxisLiveStream";
import LegacyLiveStream from "./LegacyLiveStream";

let stream_token = {};
function LiveStream() {

    const queryParameters = new URLSearchParams(window.location.search);
    const t = queryParameters.get("token"); //LZString.compressToBase64('usertest 7551ef0e-a567-415d-8794-a2f71d104420 B8A44F6E9A24 7777963129656 7939109343256'); //;
    let device_type = queryParameters.get("type") || 'Axis';

    try {
        const stream_token_lzd = LZString.decompressFromBase64(t);
        console.log('Stream Token LZD : ' + stream_token_lzd);
        const stream_token_parts = stream_token_lzd.split(' ');

        if (stream_token_parts.length < 5)
            throw new Error('Not a valid stream token');

        const stream_keys = ['user_login', 'user_token', 'device_id', 'site_id', 'location_id', 'user_type'];
        for (let i = 0; i < Math.min(stream_keys.length, stream_token_parts.length); i++) {
            stream_token[stream_keys[i]] = stream_token_parts[i];
        }
        console.log('Stream Token Final : ', stream_token);
    } catch (e) {
        stream_token = null;
        Toastr.info('Streaming url is invalid', () => window.location = '/');
    }

    let liveStreamContent;
    if (device_type === stream_token.device_id)
        device_type = 'legacy';

    switch (device_type && device_type.toLowerCase()) {
        case 'axis':
            liveStreamContent = <AxisLiveStream stream_token={stream_token}></AxisLiveStream>
            break;

        case 'legacy':
            liveStreamContent = <LegacyLiveStream stream_token={stream_token}></LegacyLiveStream>
            break;

        default:
            liveStreamContent = <div className="ant-modal-mask stream-mask d-flex justify-content-center" ><span className="align-self-center text-white">Live Streaming not supported for this device</span></div>
            break;
    }

    return <>
        {liveStreamContent}
    </>
}

export default LiveStream;